import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {SetVendorConfigurationDto} from "../../auto-generated-server-dtos/adjuster/configuration/set-vendor-configuration-dto";

@Injectable({
  providedIn: 'root'
})
export class SetVendorConfigurationService {

  constructor(private httpClient: HttpClient) { }

  setVendorConfiguration(setVendorConfiguration: SetVendorConfigurationDto) {
    return this.httpClient.put(`${environment.apiServer}/Adjuster/Configuration/SetVendorConfiguration`, { ...setVendorConfiguration });
  }
}
